import { render } from "./RekionSearchResult.vue?vue&type=template&id=41c09296&scoped=true&ts=true"
import script from "./RekionSearchResult.vue?vue&type=script&lang=ts"
export * from "./RekionSearchResult.vue?vue&type=script&lang=ts"

import "./RekionSearchResult.vue?vue&type=style&index=0&id=41c09296&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c09296"]])

export default __exports__